import { createSlice, PayloadAction } from '@reduxjs/toolkit';
import { CultureIndexCulture } from 'types/Meteorology/Agro/CultureIndex/culture';
import { CultureIndexPhenologicalStage } from 'types/Meteorology/Agro/CultureIndex/phenologicalStage';

interface MeteorologyAgroCultureIndexLocationState {
  groupId: number | undefined,
  locationId: number | undefined,
  culture: CultureIndexCulture | undefined,
  forecastDate: string | undefined,
  periodStart: string | undefined,
  periodEnd: string | undefined,
  stage: CultureIndexPhenologicalStage | undefined,
  triggerRequest: (() => void) | undefined,
}

const initialState: MeteorologyAgroCultureIndexLocationState = {
  groupId: undefined,
  locationId: undefined,
  culture: undefined,
  forecastDate: undefined,
  periodStart: undefined,
  periodEnd: undefined,
  stage: undefined,
  triggerRequest: undefined,
};

export const meteorologyAgroCultureIndexLocationSlice = createSlice({
  name: 'meteorologyAgroCultureIndexLocation',
  initialState,
  reducers: {
    reset: (state) => {
      const keepTriggerRequest = state.triggerRequest;

      Object.assign(state, {
        ...initialState,
        triggerRequest: keepTriggerRequest,
      });
    },

    setGroupId: (state, action: PayloadAction<number | undefined>) => {
      state.groupId = action.payload;
    },

    setLocationId: (state, action: PayloadAction<number | undefined>) => {
      state.locationId = action.payload;
    },

    setCulture: (state, action: PayloadAction<CultureIndexCulture | undefined>) => {
      state.culture = action.payload;

      if (!action.payload) {
        state.stage = undefined;
      }
    },

    setForecastDate: (state, action: PayloadAction<string | undefined>) => {
      state.forecastDate = action.payload;
    },

    setPeriodStart: (state, action: PayloadAction<string | undefined>) => {
      state.periodStart = action.payload;
    },

    setPeriodEnd: (state, action: PayloadAction<string | undefined>) => {
      state.periodEnd = action.payload;
    },

    setStage: (state, action: PayloadAction<CultureIndexPhenologicalStage | undefined>) => {
      state.stage = action.payload;
    },

    setTriggerRequest: (state, action: PayloadAction<(() => void) | undefined>) => {
      state.triggerRequest = action.payload;
    },
  },
});

export const selectMeteorologyAgroCultureIndexLocationGroupId = (state: any) => (
  state.meteorologyAgroCultureIndexLocation.groupId
);

export const selectMeteorologyAgroCultureIndexLocationLocationId = (state: any) => (
  state.meteorologyAgroCultureIndexLocation.locationId
);

export const selectMeteorologyAgroCultureIndexLocationCulture = (state: any) => (
  state.meteorologyAgroCultureIndexLocation.culture
);

export const selectMeteorologyAgroCultureIndexLocationForecastDate = (state: any) => (
  state.meteorologyAgroCultureIndexLocation.forecastDate
);

export const selectMeteorologyAgroCultureIndexLocationPeriodStart = (state: any) => (
  state.meteorologyAgroCultureIndexLocation.periodStart
);

export const selectMeteorologyAgroCultureIndexLocationPeriodEnd = (state: any) => (
  state.meteorologyAgroCultureIndexLocation.periodEnd
);

export const selectMeteorologyAgroCultureIndexLocationStage = (state: any) => (
  state.meteorologyAgroCultureIndexLocation.stage
);

export const selectMeteorologyAgroCultureIndexLocationTriggerRequest = (state: any) => (
  state.meteorologyAgroCultureIndexLocation.triggerRequest
);

export const {
  reset,
  setGroupId,
  setLocationId,
  setCulture,
  setForecastDate,
  setPeriodStart,
  setPeriodEnd,
  setStage,
  setTriggerRequest,
} = meteorologyAgroCultureIndexLocationSlice.actions;

export default meteorologyAgroCultureIndexLocationSlice.reducer;
